import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { Button } from '@src/design-system/button';
import { ViewReminderLogDialogContent } from '@src/shared/features/reminders/dialogs/view-reminder-log-dialog';
import type { TReminderLog } from '@src/shared/types/reminder';
import type { Row } from '@tanstack/react-table';
import { Eye } from 'iconsax-react';

export function AutomatedReminderLogViewButton({
  row,
}: {
  row: Row<TReminderLog>;
}) {
  return (
    <Dialog>
      <DialogTrigger
        // disabled
        asChild
      >
        <Button
          type='button'
          variant='ghost'
          size='iconSm'
          aria-label='View reminder'
        >
          <Eye
            size={18}
            variant='TwoTone'
          />
        </Button>
      </DialogTrigger>
      <DialogContent
        dialogOverlayProps={{
          className: 'bg-transparent',
        }}
        className='flex w-full max-w-[78%] flex-col overflow-hidden p-0 gap-0 sm:rounded-xl'
      >
        <ViewReminderLogDialogContent log={row.original} />
      </DialogContent>
    </Dialog>
  );
}
